import React from "react";

import "./text.scss";

const Text = ({ children }) => <div className="Text">{children}</div>;

export default Text;
